<!-- 组件说明 -->
<template>
  <a-modal
    :width="733"
    :visible="visible"
    title="审核素材"
    @ok="handleOk"
    @cancel="handleOk"
  >
    <a-spin :spinning="spinning"> </a-spin>
    <template
      v-if="this.record.status == 1 || this.record.status == 2"
      slot="footer"
    >
      <a-button key="reject" @click="operation(2)">
        审核拒绝
      </a-button>
      <a-button
        key="agree"
        type="primary"
        :loading="loading"
        @click="operation(1)"
      >
        审核通过
      </a-button>
    </template>
    <template v-else slot="footer">
      <a-button key="reject" @click="$emit('cancle')">
        取消
      </a-button>
      <a-button
        key="agree"
        type="primary"
        :loading="loading"
        @click="$emit('cancle')"
      >
        确定
      </a-button>
    </template>
    <div style="margin-left:72px;">素材类型：{{ record.materialName }}</div>

    <!-- 话术 -->
    <div style="margin-top: 20px;" v-if="modaldata.speechcraft">
      <div
        v-if="modaldata.speechcraft.msgType == 'text'"
        style="display:flex;margin-left:72px;margin-top:27px;"
      >
        <p>文本内容：</p>
        <div
          style="background:#F0F0F0;width:481px;box-sizing:border-box;padding:12px 17px 16px 29px;"
        >
          <p v-html="modaldata.speechcraft.content"></p>
        </div>
      </div>
      <a-form-item
        style="margin-top:10px;"
        v-if="modaldata.speechcraft.msgType == 'image'"
        label="图片内容"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <img class="imgclass" :src="modaldata.speechcraft.imgUrl" />
      </a-form-item>
      <div v-if="modaldata.speechcraft.msgType == 'news'">
        <a-form-item
          label="链接内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item
            label="链接地址"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <!-- <input type="text" :value="modaldata.speechcraft.link" disabled> -->
            {{ modaldata.speechcraft.link }}
          </a-form-item>
          <a-form-item
            label="图文标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <!-- <input type="text" :value="modaldata.speechcraft.title" disabled> -->
            {{ modaldata.speechcraft.title }}
          </a-form-item>
          <a-form-item
            label="图文封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <!-- <j-image-upload file-type="file" accept=".jpg, .png" text="上传" fileKey="picFile"
              :value='modaldata.speechcraft.url' :url="modaldata.speechcraft.url">
            </j-image-upload> -->
            <img class="imgclassnews" :src="modaldata.speechcraft.newsUrl" />
          </a-form-item>
          <a-form-item
            label="图文描述"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <!-- <a-textarea :value="modaldata.speechcraft.link" disabled /> -->
            {{ modaldata.speechcraft.desc }}
          </a-form-item>
        </a-form-item>
      </div>
      <div v-if="modaldata.speechcraft.msgType == 'miniprogram'">
        <a-form-item
          label="小程序"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item
            label="appid"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.speechcraft.appid }}
          </a-form-item>
          <a-form-item
            label="消息标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.speechcraft.title }}
          </a-form-item>
          <a-form-item
            label="小程序封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <img class="imgclassnews" :src="modaldata.speechcraft.minUrl" />
          </a-form-item>
          <a-form-item
            label="页面路径"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.speechcraft.page }}
          </a-form-item>
        </a-form-item>
      </div>
      <div v-if="modaldata.speechcraft.msgType == 'file'">
        <a-form-item label="文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!-- <a :href="modaldata.speechcraft.fileName">{{modaldata.speechcraft.fileName}}</a> -->
          <a-upload :file-list="defaultFileListFile"> </a-upload>
        </a-form-item>
      </div>
      <div v-if="modaldata.speechcraft.msgType == 'video'">
        <a-form-item
          label="视频 "
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-upload :file-list="defaultFileListVideo"> </a-upload>
        </a-form-item>
      </div>
    </div>
    <!-- 欢迎语 -->
    <div style="margin-top: 20px;" v-if="modaldata.welcomeInfo">
      <div
        v-if="modaldata.welcomeInfo.textContent"
        style="display:flex;margin-left:72px;margin-top:27px;"
      >
        <p>文本内容：</p>
        <div
          style="background:#F0F0F0;width:481px;box-sizing:border-box;padding:12px 17px 16px 29px;"
        >
          {{ modaldata.welcomeInfo.textContent }}
        </div>
      </div>
      <a-form-item
        style="margin-top:10px;"
        v-if="modaldata.welcomeInfo.imagePicUrl"
        label="图片内容"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <img class="imgclass" :src="modaldata.welcomeInfo.imagePicUrl" />
      </a-form-item>
      <div v-if="modaldata.welcomeInfo.linkTitle">
        <a-form-item
          label="链接内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item
            label="链接地址"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.welcomeInfo.linkUrl }}
          </a-form-item>
          <a-form-item
            label="链接标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.welcomeInfo.linkTitle }}
          </a-form-item>
          <a-form-item
            label="链接封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <img class="imgclassnews" :src="modaldata.welcomeInfo.linkPicurl" />
            <!-- {{modaldata.welcomeInfo.linkPicurl}} -->
          </a-form-item>
          <a-form-item
            label="图文描述"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.welcomeInfo.linkDesc }}
          </a-form-item>
        </a-form-item>
      </div>
      <div v-if="modaldata.welcomeInfo.miniprogramTitle">
        <a-form-item
          label="小程序"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item
            label="appid"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.welcomeInfo.miniprogramAppid }}
          </a-form-item>
          <a-form-item
            label="消息标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.welcomeInfo.miniprogramTitle }}
          </a-form-item>
          <a-form-item
            label="小程序封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <img
              class="imgclassnews"
              :src="modaldata.welcomeInfo.miniprogramPicMediaId"
            />
          </a-form-item>
          <a-form-item
            label="页面路径"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.welcomeInfo.miniprogramPage }}
          </a-form-item>
        </a-form-item>
      </div>
    </div>

    <!-- 群发 -->
    <div style="margin-top: 20px;" v-if="modaldata.groupSend">
      <div
        v-if="modaldata.groupSend.document"
        style="display:flex;margin-left:72px;margin-top:27px;"
      >
        <p>文本内容：</p>
        <div
          style="background:#F0F0F0;width:481px;box-sizing:border-box;padding:12px 17px 16px 29px;"
        >
          {{ modaldata.groupSend.document }}
        </div>
      </div>
      <a-form-item
        style="margin-top:10px;"
        v-if="modaldata.groupSend.imgpicurl"
        label="图片内容"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <img class="imgclass" :src="modaldata.groupSend.imgpicurl" />
      </a-form-item>
      <div v-if="modaldata.groupSend.linktitle">
        <a-form-item
          label="链接内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item
            label="链接地址"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.groupSend.linkurl }}
          </a-form-item>
          <a-form-item
            label="链接标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.groupSend.linktitle }}
          </a-form-item>
          <a-form-item
            label="链接封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <img class="imgclassnews" :src="modaldata.groupSend.linkpicurl" />
            <!-- {{modaldata.groupSend.linkpicurl}} -->
          </a-form-item>
          <a-form-item
            label="图文描述"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.groupSend.linkdesc }}
          </a-form-item>
        </a-form-item>
      </div>
      <div v-if="modaldata.groupSend.minititle">
        <a-form-item
          label="小程序"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-form-item
            label="appid"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.groupSend.miniappid }}
          </a-form-item>
          <a-form-item
            label="消息标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.groupSend.minititle }}
          </a-form-item>
          <a-form-item
            label="小程序封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <img
              class="imgclassnews"
              :src="modaldata.groupSend.minipicmediaid"
            />
          </a-form-item>
          <a-form-item
            label="页面路径"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            {{ modaldata.groupSend.minipage }}
          </a-form-item>
        </a-form-item>
      </div>
    </div>

    <div style="margin:100px 0 20px 10px">
      <a-table
        bordered
        size="middle"
        :columns="columns"
        :dataSource="modaldata.examineHistorys"
        :loading="loading"
        :rowKey="r => r.id"
      >
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { getExamineDetail, getExamineList, changeExamine } from '@/api/api';
import { axios } from '@/utils/request';
import qs from 'qs';
import JImageUpload from '@/components/jeecg/JImageUpload';
export default {
  name: 'examineModal',
  props: ['visible'],
  components: {
    JImageUpload
  },
  data() {
    return {
      columns: [
        {
          title: '审核人',
          align: 'center',
          dataIndex: 'examineName',
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            }
            let list = JSON.parse(sessionStorage.getItem('CREATEPOPLIST'));
            let textTemp = text.toLocaleLowerCase();
            let target = list.find(
              item => item.userName.toLocaleLowerCase() == textTemp
            );
            if (target) {
              return target.realName;
            } else {
              return text;
            }
          }
        },
        {
          title: '审核时间',
          align: 'center',
          dataIndex: 'examineTime'
        },
        {
          title: '审核结果',
          align: 'center',
          dataIndex: 'examineResult',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '审核通过';
            } else if (text == 2) {
              return '审核拒绝';
            }
          }
        }
      ],
      value: 2,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      modaldata: {},
      loading: false,
      record: {},
      spinning: false,
      defaultFileListVideo: [
        {
          name: '',
          url: '',
          uid: '',
          status: ''
        }
      ],
      defaultFileListFile: [
        {
          name: '',
          url: '',
          uid: '',
          status: ''
        }
      ],
      minUrl: process.env.VUE_APP_FILE_PATH
    };
  },
  computed: {
    // defaultFileList() {
    //   let arr = []
    //   arr.push(this.modaldata.speechcraft.videoUrl)
    //   return arr;
    // }
  },
  methods: {
    operation(option) {
      // changeExamine({
      //   id: this.record.id,
      //   operate: option,
      //   type: this.record.materialType
      // })
      axios(
        process.env.VUE_APP_CMS_EXAMINE + '/wechatwork/examine/examineResult',
        {
          method: 'post',
          data: {
            id: this.record.id,
            operate: option,
            type: this.record.materialType
          }
        }
      ).then(res => {
        if (res.success) {
          this.$message.success('操作成功');
        } else {
          this.$message.warn('操作失败');
        }
      });
      this.$emit('ok');
    },
    handleCancel() {
      this.$emit('ok');
    },
    handleOk() {
      this.$emit('cancle');
    },
    getdata(record) {
      console.warn(record);
      this.spinning = true;
      this.record = record;
      getExamineDetail({
        id: record.id,
        materialType: record.materialType
      })
        .then(res => {
          this.spinning = false;
          this.defaultFileListVideo = [
            {
              name: '',
              url: '',
              uid: '',
              status: ''
            }
          ];
          this.defaultFileListFile = [
            {
              name: '',
              url: '',
              uid: '',
              status: ''
            }
          ];
          this.modaldata = res.result;
          console.warn(this.modaldata);
          if (this.modaldata.speechcraft) {
            this.modaldata.speechcraft.imgUrl =
              process.env.VUE_APP_FILE_PATH + res.result.speechcraft.imgUrl;
            this.modaldata.speechcraft.newsUrl =
              process.env.VUE_APP_FILE_PATH + res.result.speechcraft.newsUrl;
            this.modaldata.speechcraft.minUrl =
              process.env.VUE_APP_FILE_PATH + res.result.speechcraft.minUrl;

            this.defaultFileListVideo[0].name = res.result.speechcraft.fileName;
            this.defaultFileListVideo[0].url = res.result.speechcraft.videoUrl;
            this.defaultFileListVideo[0].uid = '1';
            this.defaultFileListVideo[0].status = 'done';
            // obj.response = 'Server Error 500';

            this.defaultFileListFile[0].name = res.result.speechcraft.fileName;
            this.defaultFileListFile[0].url = res.result.speechcraft.fileUrl;
            this.defaultFileListFile[0].uid = '10';
            this.defaultFileListFile[0].status = 'done';
            if (this.modaldata.speechcraft.content) {
              this.modaldata.speechcraft.content = this.modaldata.speechcraft.content.replace(
                /\n/g,
                '<br/>'
              );
            }

            // obj2.response = 'Server Error 500';
          }
          if (this.modaldata.welcomeInfo) {
            this.modaldata.welcomeInfo.imagePicUrl =
              process.env.VUE_APP_FILE_PATH +
              res.result.welcomeInfo.imagePicUrl;
            this.modaldata.welcomeInfo.linkPicurl =
              process.env.VUE_APP_FILE_PATH + res.result.welcomeInfo.linkPicurl;
            this.modaldata.welcomeInfo.miniprogramPicMediaId =
              process.env.VUE_APP_FILE_PATH + res.result.welcomeInfo.programUrl; //res.result
            //.welcomeInfo.miniprogramPicMediaId
          }
          if (this.modaldata.groupSend) {
            this.modaldata.groupSend.imgpicurl =
              process.env.VUE_APP_FILE_PATH + res.result.groupSend.imgpicurl;
            this.modaldata.groupSend.linkpicurl =
              process.env.VUE_APP_FILE_PATH + res.result.groupSend.linkpicurl;
            this.modaldata.groupSend.minipicmediaid =
              process.env.VUE_APP_FILE_PATH + res.result.groupSend.programUrl;
            //  res.result.groupSend.minipicmediaid
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.imgclass {
  width: 300px;
}

.imgclassnews {
  width: 100px;
}
</style>
